module.exports = __webpack_public_path__ + "img/arrow-5fe06cf55d77d73daa4ee46286fe94d6.svg";